import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';
import { ListGroup, ListGroupItem } from 'reactstrap';

import displayUserName from 'src/util/i18n/decorators/displayUserName';
import buildTimeRangeSummary from 'src/util/i18n/timeRange';
import isActive from 'src/util/isActive';

/**
 * Description
 * @param {any} props
 * @returns {React.ReactComponentElement} - PropertySettingsUsers component
 */
function PropertySettingsUsers(props) {
  const { property } = props;
  const { propertyUsers } = property;
  const intl = useIntl();

  return (
    <ListGroup className="property-users">
      {propertyUsers && propertyUsers.edges && propertyUsers.edges.map((edge) => {
        const { node } = edge;
        const { uuid, active, user } = node;
        const { email } = user;

        if (!isActive(active)) {
          return null;
        }

        return (
          <ListGroupItem key={uuid}>
            <div>
              <strong>{displayUserName(intl, user)}</strong>
            </div>
            <div>
              {email}
            </div>
            <div>
              {buildTimeRangeSummary(intl, active)}
            </div>
          </ListGroupItem>
        );
      })}
    </ListGroup>
  );
}

PropertySettingsUsers.propTypes = {
  property: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default createFragmentContainer(
  PropertySettingsUsers,
  {
    property: graphql`
      fragment PropertySettingsUsers_property on Property {
        propertyUsers(first: 500) {
          edges {
            node {
              uuid
              externalIdentifier
              active { start finish }
              user {
                uuid
                externalIdentifier
                email
                givenName
                familyName
                active { start finish }
              }
            }
          }
        }
      }
    `,
  },
);
